import React, { useState, useEffect } from 'react';
import '../App.css';

function Admin() {
  const [systemInfo, setSystemInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading system information
    setTimeout(() => {
      setSystemInfo({
        serverTime: new Date().toLocaleString(),
        tailscaleStatus: 'Connected',
        userAgent: navigator.userAgent,
        connectionType: 'Tailscale Network',
        lastAccess: new Date().toLocaleString()
      });
      setIsLoading(false);
    }, 1000);
  }, []);

  const handleTestAction = () => {
    alert('Test action executed! This is only available through Tailscale.');
  };

  if (isLoading) {
    return (
      <div className="admin-container">
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading admin panel...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-container">
      <div className="admin-header">
        <h1>🔒 Admin Panel</h1>
        <p className="admin-subtitle">Tailscale-Protected Area</p>
        <div className="status-badge">
          <span className="status-dot"></span>
          Secure Connection Active
        </div>
      </div>

      <div className="admin-grid">
        <div className="admin-card">
          <h3>🌐 Connection Info</h3>
          <div className="info-grid">
            <div className="info-item">
              <span className="label">Status:</span>
              <span className="value success">{systemInfo.tailscaleStatus}</span>
            </div>
            <div className="info-item">
              <span className="label">Network:</span>
              <span className="value">{systemInfo.connectionType}</span>
            </div>
            <div className="info-item">
              <span className="label">Server Time:</span>
              <span className="value">{systemInfo.serverTime}</span>
            </div>
          </div>
        </div>

        <div className="admin-card">
          <h3>📊 Wedding Website Stats</h3>
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">831</div>
              <div className="stat-label">Wedding Photos</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">4</div>
              <div className="stat-label">Gallery Pages</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">100%</div>
              <div className="stat-label">Secured</div>
            </div>
          </div>
        </div>

        <div className="admin-card full-width">
          <h3>⚡ Quick Actions</h3>
          <div className="actions-grid">
            <button className="action-btn primary" onClick={handleTestAction}>
              🧪 Test Function
            </button>
            <button className="action-btn secondary" onClick={() => window.location.reload()}>
              🔄 Refresh Panel
            </button>
            <button className="action-btn secondary" onClick={() => window.open('/df', '_blank')}>
              📸 View Gallery
            </button>
            <button className="action-btn warning" onClick={() => alert('This would clear cache in a real implementation')}>
              🗑️ Clear Cache
            </button>
          </div>
        </div>

        <div className="admin-card full-width">
          <h3>🔍 System Information</h3>
          <div className="system-info">
            <div className="info-row">
              <strong>User Agent:</strong>
              <span className="mono">{systemInfo.userAgent}</span>
            </div>
            <div className="info-row">
              <strong>Last Access:</strong>
              <span>{systemInfo.lastAccess}</span>
            </div>
            <div className="info-row">
              <strong>Access Method:</strong>
              <span className="success">Tailscale Network ✅</span>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .admin-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
          padding: 20px;
          color: white;
        }

        .loading {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 60vh;
        }

        .spinner {
          width: 40px;
          height: 40px;
          border: 4px solid rgba(255, 255, 255, 0.3);
          border-left: 4px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-bottom: 20px;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .admin-header {
          text-align: center;
          margin-bottom: 40px;
        }

        .admin-header h1 {
          font-size: 2.5rem;
          margin-bottom: 10px;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
        }

        .admin-subtitle {
          font-size: 1.2rem;
          opacity: 0.9;
          margin-bottom: 20px;
        }

        .status-badge {
          display: inline-flex;
          align-items: center;
          background: rgba(46, 204, 113, 0.2);
          border: 1px solid #2ecc71;
          padding: 8px 16px;
          border-radius: 20px;
          font-size: 0.9rem;
        }

        .status-dot {
          width: 8px;
          height: 8px;
          background: #2ecc71;
          border-radius: 50%;
          margin-right: 8px;
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0% { opacity: 1; }
          50% { opacity: 0.5; }
          100% { opacity: 1; }
        }

        .admin-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 20px;
          max-width: 1200px;
          margin: 0 auto;
        }

        .admin-card {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 12px;
          padding: 24px;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          transition: transform 0.2s ease;
        }

        .admin-card:hover {
          transform: translateY(-2px);
        }

        .admin-card.full-width {
          grid-column: 1 / -1;
        }

        .admin-card h3 {
          margin: 0 0 20px 0;
          font-size: 1.3rem;
        }

        .info-grid, .stats-grid {
          display: grid;
          gap: 12px;
        }

        .info-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 0;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }

        .info-item:last-child {
          border-bottom: none;
        }

        .label {
          font-weight: 600;
        }

        .value {
          font-family: 'SF Mono', Monaco, monospace;
        }

        .value.success {
          color: #2ecc71;
        }

        .stats-grid {
          grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
        }

        .stat-item {
          text-align: center;
        }

        .stat-number {
          font-size: 2rem;
          font-weight: bold;
          color: #f39c12;
        }

        .stat-label {
          font-size: 0.9rem;
          opacity: 0.9;
          margin-top: 4px;
        }

        .actions-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 12px;
        }

        .action-btn {
          padding: 12px 20px;
          border: none;
          border-radius: 8px;
          font-size: 0.9rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .action-btn.primary {
          background: #3498db;
          color: white;
        }

        .action-btn.secondary {
          background: rgba(255, 255, 255, 0.2);
          color: white;
        }

        .action-btn.warning {
          background: #e67e22;
          color: white;
        }

        .action-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0,0,0,0.2);
        }

        .system-info {
          display: grid;
          gap: 12px;
        }

        .info-row {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .mono {
          font-family: 'SF Mono', Monaco, monospace;
          font-size: 0.8rem;
          opacity: 0.8;
          word-break: break-all;
        }

        .success {
          color: #2ecc71;
        }

        @media (max-width: 768px) {
          .admin-grid {
            grid-template-columns: 1fr;
          }
          
          .admin-header h1 {
            font-size: 2rem;
          }
          
          .actions-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
}

export default Admin;